The advertisement branding for the given `id`.

This query accepts browser tokens that include the `query:advertisement-brandings` or `query:enhanced-job-posting` scope.
